import InlineAlert from "@storeblocks/inline-alert";
import { useTexts } from "Components/TextContext";
import { isChildCloseToMaxAge } from "Utils/ageUtils";
import { isDefined, isEmpty } from "Utils/functions";
import { parse } from "date-fns";
import { useFormikContext } from "formik";
import React from "react";
import { AKA_CHILD_END_AGE, AKA_CHILD_MAX_AGE } from "../akaChildConstants";
import { AkaChildProductDetailsFormValues } from "./akaChildProductDetailsInterfaces";

export const CloseToMaxAgeWarning = (): React.ReactElement | null => {
  const formProps = useFormikContext<AkaChildProductDetailsFormValues>();
  const { getText } = useTexts();

  if (
    !isEmpty(formProps.errors.childBirthDate) ||
    !isDefined(formProps.values.childBirthDate) ||
    !isChildCloseToMaxAge(
      parse(formProps.values.childBirthDate, "dd.MM.yyyy", new Date()),
      AKA_CHILD_MAX_AGE,
    )
  ) {
    return null;
  }

  return (
    <InlineAlert
      title={getText("akachildform.warning.closetomaxage", {
        variables: {
          maxAge: AKA_CHILD_MAX_AGE,
          endAge: AKA_CHILD_END_AGE,
        },
      })}
    />
  );
};
